export const parseHashFromProps = (props) => {
  const hash = props.location?.hash?.replace('#', '').split('');

  if (!hash || hash.length === 0) {
    return {
      page: 1,
      letter: '',
    };
  }

  let letter = hash.shift();
  if (letter === '_') {
    letter = '';
  }

  const page = parseInt(hash.join(''), 10);

  return {
    page,
    letter,
  };
}

export const buildHash = (pageNumber, filterLetter) => {
  if ((pageNumber || 0) <= 1&& !filterLetter) {
    return '';
  }

  return `${filterLetter || '_'}${pageNumber}`;
}
